<template>
  <div class="doc-container">
    <h1>赛刻体育用户购买协议</h1>
    <p>
      您在注册、登录赛刻体育平台、使用赛刻体育平台购买服务之前，应当认真阅读并充分理解《赛刻体育用户购买协议》（以下简称“本协议”）中各条款。您应该具备中华人民共和国法律规定的与您行为相适应的民事行为能力。若您不具备签署与您行为相适应的民事行为能力，请确保您的监护人同意您的所有行为，在此情况下，您及您的监护人应依照法律规定承担因此而导致的一切后果。
    </p>
    <p>
      免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。如果您对本协议的任何条款表示异议，或者无法准确理解本协议，请不要使用赛刻体育平台购买服务。您使用购买服务等行为视为对本协议全部内容的接受，也意味您将接受本协议以及未来针对本协议更新版本条款的约束，并服从赛刻体育平台统一管理。赛刻体育可能会不定期的更新本协议内容，用户可在赛刻体育软件内页或网页查阅最新版协议条款。更新后的协议条款一旦公布即代替原来的协议条款。协议条款更新后，如用户不同意接受，用户应停止使用赛刻体育提供的服务。
    </p>
    <p>
      本协议是您（以下简称“用户”）与赛刻体育平台（以下简称
      “赛刻体育”）之间关于使用赛刻体育购买服务所订立的协议。“用户”是指注册、登录、使用赛刻体育购买服务的个人。
    </p>
    <p>
      赛刻体育是赛刻体育是为广大竞彩爱好者提供足彩、篮彩等竞彩体育赛事数据分析、赛事解读的数据服务平台（以下简称：“赛刻体育服务”）。
    </p>
    <p>
      账户充值是指通过赛刻体育账号购买赛刻体育虚拟币的行为。（以下简称“充值”“账户充值”或“购买金豆”）。充值服务，是指赛刻体育为用户提供购买虚拟币的相应服务（以下简称“充值服务”）。
    </p>
    <p>
      按照相关赛刻体育公布及不时更新的购买规则（以下简称“购买规则”），用户可以通过账户充值使用虚拟币购买（以下简称：“充值虚拟币购买”）或通过赛刻体育认可的支付方式，直接购买赛刻体育服务（以下简称“直接购买”）充值虚拟币购买和直接购买以下统称“购买服务”。
    </p>
    <p>一、购买服务程序</p>
    <p>1. 充值虚拟币购买</p>
    <p>
      （1）“金豆”是赛刻体育向用户提供的用于在赛刻体育上进行相关消费的虚拟货币，用户可依照购买规则，先进行账户充值，购买虚拟币“金豆”，然后使用使用充值账号内的“金豆”购买赛刻体育某项产品或服务。
      用户了解及确认，用户购买及使用“金豆”的范围以赛刻体育认可的范围为准。
    </p>
    <p>
      （2）用户了解并确认，各应用商店可能会对充值渠道、充值频率等进行限定，并可能会要求赛刻体育隔离不同系统、不同应用商店适用的移动客户端及/或未来增加的赛刻体育平台的帐户信息，包括帐户余额、帐户交易记录等。
    </p>
    <p>1. 直接购买</p>
    <p>
      （1）用户可按照购买规则，通过赛刻体育认可的支付方式，直接购买赛刻体育的某项产品或服务。如用户希望使用直接购买服务，需先登录用户的赛刻体育帐号。
      用户了解及确认，用户可直接购买的赛刻体育服务以赛刻体育认可的范围为准。
    </p>
    <p>
      （2）对于采用按期限结账方式的赛刻体育服务，用户
      购买时，可自行选择有效期。有效期自用户购买 服务
      之时起算，用户可在赛刻体育“我的”页面内查看有效期。无论用户是否使用本服务，有效期届满，
      相应服务终止。
    </p>
    <p>二、充值服务及/或购买服务规则</p>
    <p>
      1.
      用户在使用充值服务及/或购买服务时，务必仔细了解本协议及赛刻体育不时公布和更新的各项规则，并根据赛刻体育操作提示，确认自己的账号并选择相关操作选项。
      使用充值服务及/或购买服务时，用户应确保用户是该充值及/或购买账户的权利人，可合法、有效使用该账户且未侵犯任何第三方合法权益，否则因此造成充值及/或购买账户实际所有人损失的，用户应单独负责解决由此产生的纠纷并承担全部法律责任。
    </p>
    <p>
      2.
      一旦账号充值成功，除法律规定的情形及本协议另有约定外，赛刻体育不会就帐户内的“金豆”余额提供任何退还或逆向兑换（即“金豆”兑换为人民币或其他货币）服务。
    </p>
    <p>
      3.
      用户在使用购买服务时，应仔细核对赛刻体育帐号名称、服务类型、服务费用/金豆与服务有效期等具体信息。一旦购买成功，除法律规定的情形及本协议另有约定外，赛刻体育不予退还已收取的费用/金豆。
    </p>
    <p>
      4.
      用户使用购买服务购买的内容仅限于用户自行使用，不能在不同的赛刻体育用户帐号之间转移。
    </p>
    <p>
      5.
      如果赛刻体育发现因赛刻体育平台系统故障导致的充值/购买结果处理错误，无论有利于赛刻体育还是有利于用户，赛刻体育都有权在以赛刻体育平台公告或其他合理方式通知用户后纠正该错误。其中，如果该措施导致用户实际充值购买的“金豆”数量少于用户应获得的“金豆”及/或实际购买的赛刻体育服务数量少于用户应获得的赛刻体育服务，则用户有权通知赛刻体育。赛刻体育在调查及确认该处理错误后会尽快将差额补足至用户的账户中，或进行线下退款处理。如果该错误导致用户实际收到的“金豆”数量多于用户应获得的“金豆”及/或实际购买的赛刻体育服务数量多于用户应获得的赛刻体育服务，则无论错误的性质和原因如何，赛刻体育有权从用户的账户中直接扣除多得的“金豆”及/或服务。
    </p>
    <p>三、权利声明</p>
    <p>
      1. 用户可随时在赛刻体育
      “我的”页面查看其“金豆”的余额情况及/或查看赛刻体育服务的购买情况。如用户对上述记录有异议，应立即向赛刻体育提出，赛刻体育调查核对后确有错误的，将予以更正。否则用户同意赛刻体育上的交易记录将作为“金豆”交易、余额情况、赛刻体育服务购买情况的唯一有效依据。
    </p>
    <p>
      2.
      因用户自身的原因导致赛刻体育无法提供充值服务/购买服务或提供充值服务/购买服务时发生任何错误而产生的任何损失，由用户自行负责，赛刻体育不提供退、换服务，亦不会作出任何补偿或赔偿，包括但不限于：
    </p>
    <p>
      （1）用户未按照本协议或赛刻体育不时公布和更新的规则进行充值服务/购买服务操作；
    </p>
    <p>（2）因用户的账号失效、丢失、被封停；</p>
    <p>
      （3）因用户自身输入账号错误、操作不当等因素造成充错账号、错选购买种类、错选购买金额、错选购买服务有效期；
    </p>
    <p>
      （4）因用户绑定的第三方支付账户之原因导致的损失，包括但不限于第三方支付账户被冻结、查封等；
    </p>
    <p>（5）因用户设置或保管密码不当导致的财产损失；</p>
    <p>（6）因用户个人的故意或重大过失所造成的财产损失。</p>
    <p>四、处罚规则</p>
    <p>如用户实施了下列行为之一：</p>
    <p>1. 以营利为目的为自己或他人获得充值服务及/或购买服务的；</p>
    <p>
      2. 将通过充值服务及/或购买服务获得的任何内容用于本协议约定之外用途的；
    </p>
    <p>3. 盗用他人赛刻体育帐号进行充值服务及/或购买或使用的；</p>
    <p>
      4.
      以任何系统BUG、漏洞、机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它非正规方式获得充值服务及/或购买服务的；
    </p>
    <p>
      5.
      其他通过不正当手段或以违反诚实信用原则的行为获得充值服务及/或购买服务的。
    </p>
    <p>
      赛刻体育及其关联公司有完全的权利在不通知用户的情况下，视严重情况，对用户同时采取以下单项或多项措施进行处罚，同时赛刻体育及其关联公司无须给予用户任何补偿和退费、不予返还用户购买“金豆”所支付的对价，由此产生的责任由用户自行独立承担。因此给赛刻体育及其关联公司或第三方造成损失的，用户应负责全额赔偿（包括但不限于赔偿金、罚金、和解费、诉讼仲裁费、合理的律师费支出等）：
    </p>
    <p>（1）暂停或终止提供全部或部分赛刻体育服务；</p>
    <p>（2）暂时限制或 永久封禁 相关用户赛刻体育帐号；</p>
    <p>（3）对相关用户赛刻体育账户中全部或部分的“金豆”余额进行冻结或清空；</p>
    <p>五、法律</p>
    <p>1. 本协议适用中华人民共和国的法律，并且排除一切冲突法规定的适用。</p>
    <p>
      2.
      因本协议引起的或与本协议有关的争议，赛刻体育可与用户协商解决。协商不成的，用户和赛刻体育一致同意将纠纷提交中国国际经济贸易仲裁委员会根据其现行有效的仲裁规则进行仲裁。仲裁地点是北京。仲裁裁决是终局的，对双方都有约束力。
    </p>
    <p>六、服务中止、中断及终止</p>
    <p>
      1.
      用户充分理解并同意：因业务发展需要、突发情势等，赛刻体育可能会变更，暂停、限制或者终止部分或全部服务。届时，如用户按照本协议约定履行义务的，赛刻体育会依法保护用户的合法权益，如用户选择终止服务的，用户有权要求赛刻体育按比例退回其充值及/或购买的剩余费用。
    </p>
    <p>七、附则</p>
    <p>
      1.
      赛刻体育不行使、未能及时行使或者未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响赛刻体育在将来行使该权利。
    </p>
    <p>
      2.
      如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议条款的其余条款仍应有效且具有约束力，赛刻体育及用户均应尽力使该协议设定的本意得到实现。
    </p>
    <p>3. 本协议中的标题仅为方便而设，不作为解释本条款的依据。</p>
    <p>4. 如有任何疑问，请添加客服微信：19142044013</p>
  </div>
</template>

<script>
import { onMounted } from "vue";

export default {
  setup() {
    onMounted(() => {
      document.title = "赛刻体育用户购买协议";
    });
  },
};
</script>

<style scoped>
/* 彻底消除顶部空白 */
.doc-container {
  min-height: 100%;
}

/* h1 标题：居中 + 美观间距 */
h1 {
  text-align: center;
  margin: 0;
  padding: 20px 0 25px 0;   /* 上方留一点呼吸空间，下方与正文保持合适间距 */
  font-size: 24px;
  font-weight: bold;
  color: #2c3e50;
}

/* 正文段落：左右对齐（两端对齐） */
p {
  margin: 0 0 12px 0;       /* 段落底部间距 */
  text-align: justify;      /* 左右对齐 */
  text-justify: inter-ideograph;  /* 中文两端对齐更好看 */
  font-size: 10.5pt;
  font-family: 等线, "Microsoft YaHei", sans-serif;
  line-height: 1.7;         /* 建议增加行高，阅读更舒适 */
}

/* 标题 h2、h3 的样式（如果后续有的话） */
h2, h3 {
  margin: 18px 0 10px 0;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
}

/* 整体容器样式 */
.doc-container {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;         /* 默认左对齐，h1单独居中 */
  color: #2c3e50;
  padding: 0 20px 30px 20px;   /* 左右留白，让正文不贴边，更美观 */
  box-sizing: border-box;
  max-width: 800px;         /* 可选：限制最大宽度，手机和电脑都好看 */
  margin: 0 auto;           /* 可选：内容居中显示 */
}
</style>
